import { FAQS } from "../lib/constants";
import useReveal from "../hooks/useReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export default function FAQ() {
  const head = useReveal();
  const list = useReveal();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-[#F8FAFC]"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={head.ref}
          className={`fade-in-up ${head.visible ? "is-visible" : ""} text-center max-w-2xl mx-auto`}
        >
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-[#00B4D8]">
            FAQ
          </span>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-base lg:text-lg text-slate-500">
            Everything you need to know about cleaning, installation, and
            maintenance.
          </p>
        </div>

        <div
          ref={list.ref}
          className={`fade-in-up ${list.visible ? "is-visible" : ""} mt-12`}
        >
          <Accordion
            type="single"
            collapsible
            className="space-y-3"
            data-testid="faq-accordion"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-white rounded-xl border border-slate-200 px-2 sm:px-4 overflow-hidden data-[state=open]:border-[#00B4D8]/40 data-[state=open]:shadow-sm transition-colors"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="px-3 sm:px-4 py-5 text-left font-heading font-semibold text-[#0A192F] text-base sm:text-lg hover:no-underline hover:text-[#00B4D8] [&[data-state=open]>svg]:text-[#00B4D8]"
                >
                  <span className="flex items-start gap-3 sm:gap-4">
                    <span className="text-[#00B4D8] font-bold text-sm sm:text-base mt-0.5 shrink-0 w-6">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span>{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="px-3 sm:px-4 pb-5 pl-12 sm:pl-14 text-slate-600 leading-relaxed text-[15px]"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
